import "@fontsource/roboto/300.css";
import React from "react";
import ReactDOM from "react-dom";
import "./@scss/index.scss";
import App from "./App";

ReactDOM.render(<App></App>, document.getElementById("root"));
